import React from "react";

const StepHeader = ({ title, onBack }) => {
  return (
    <div className="flex items-center gap-3 mb-6">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="cursor-pointer"
        onClick={onBack}
      >
        <path
          d="M12.5005 16.6004L7.06719 11.1671C6.42552 10.5254 6.42552 9.47539 7.06719 8.83372L12.5005 3.40039"
          stroke="#525252"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <p className="font-poppins font-medium text-sm leading-none">{title}</p>
    </div>
  );
};

export default StepHeader;
